export const SOFTLINE_FEATURE_PMS_MELDUNGEN = 'pmsMeldung';
export const SOFTLINE_PERMISSION_PMS_MELDUNGEN = 'PMSMELDUNG';
